<template>
    <div class="list-container home-buttons">
        <header><p>Configure Home Page</p><div class="x" @click="exit"></div></header>
        <div class="label">
            <div class="label" style="margin: 0px;">
                <p style="float: left;width: 199px;">Banner</p>
                <select v-model="homeBanner.type" style="width: 180px;float: left;" @change="updateHomeBanner"><option v-for="option in bannerOptions">{{ option }}</option></select>
            </div>
            <div v-if="homeBanner.type == 'video'" class="label" style="margin-left: 0px;display: grid;grid-template-columns: 200px 1fr;">
                <p style="line-height: 42px;">Video Link</p>
                <div>
                    <input style="float: left;font-size: 22px;padding:5px;width: 100%;" v-model="homeBanner.src" />
                    <div v-if="homeBanner.src" style="float: left;padding: 5px;border:1px solid #c0c0c0;width: 414px;margin: 10px 0px;">
                        <video :src="homeBanner.src" width="414" style="float:left;border:1px solid #c0c0c0;margin: 0px 0px">
                            <source :src="homeBanner.src" type="application/x-mpegURL"></source>
                        </video>
                    </div>
                    <div style="float: left;padding: 5px;border:1px solid #c0c0c0;width: 424px;height:235px;margin: 10px 10px;" :style="{ opacity: homeBanner.opacity }" @click="replaceHomeBannerPlaceHolder">
                        <img v-if="homeBanner.placeHolder" :src="homeBanner.placeHolder" style="width:414px;height:233px;margin:0px"/>
                        <h1 v-else class="btn" :style="{ color: btnFontColor, backgroundColor: btnColor }" style="text-align: center;margin-top: calc(25% - 20px)" >Upload Image</h1>
                    </div>
                </div>
            </div>
            <div v-if="homeBanner.type == 'image'" class="label" style="margin-left: 0px;display: grid;grid-template-columns: 200px 1fr;">
                <p>Image Banner</p>
                <div style="float: left;padding: 5px;padding-bottom: 0px;border:1px solid #c0c0c0;width: 414px;min-height: 212px;" @click="replaceHomeBannerImage">
                    <img v-if="homeBanner.src" :src="homeBanner.src" style="min-width:414px;width:414px;min-height: 200px;" :style="{ opacity: homeBanner.opacity }" />
                    <h1 v-else class="btn" :style="{ color: btnFontColor, backgroundColor: btnColor }" style="text-align: center;margin-top: calc(25% - 20px)" >Upload Image</h1>
                </div>
            </div>
        </div>
        <div class="menu-items">
            <div v-for="item in menu" class="menu-item">
                <p class="ellip">{{ item.text }}</p>
                <img :src="item.src" style="height:100px;border:1px solid #c0c0c0" :style="{ opacity: item.opacity }" @click="replaceImg(item)"/>
            </div>
        </div>
        <div class="btns">
            <p class="btn" @click="save(menu)">save</p>
        </div>
    </div>
</template>

<script>

import Alert from '../utils/Alert.js';
import WebSoc from '../utils/WebSoc.js';
import UploadFile from '../utils/UploadFile.js';
import postMinify from '../utils/postMinify.js';

export default {
    name: 'home-buttons',
    computed: {
        client_id () { return this.$store.state.client_id },
        btnColor () { return this.$store.state.btnColor },
        btnFontColor () { return this.$store.state.btnFontColor }
    },
    data () {
        return {
            homeBanner: {},
            bannerOptions: ['no banner','video','image'],
            menu: [],
            client: false
        }
    },
    mounted () {
        this.getMenu();
        console.log('this.btnColor',this.btnColor);
        console.log('this.btnFontColor',this.btnFontColor)
    },
    methods: {
        getMenu () {
            WebSoc.SEND('get',{ DB: 'clients', _id: this.client_id, project: { homeBanner: 1, menu: 1 } },client => {
                console.log('client',JSON.parse(JSON.stringify(client)));
                client.menu.forEach(item => item.opacity = 1);
                client.homeBanner = client.homeBanner || { type: 'no banner', src: '' };
                this.homeBanner = JSON.parse(JSON.stringify(client.homeBanner));
                this.homeBanner.opacity = 1;
                this.client = client;
                this.menu = client.menu;
            })
        },
        updateHomeBanner () {
            if ( this.client.homeBanner.type == this.homeBanner.type ) {
                this.homeBanner = { type: this.client.homeBanner.type, src: this.client.homeBanner.src, opacity: 1, placeHolder: this.client.homeBanner.placeHolder };
            } else {
                this.homeBanner = { type: this.homeBanner.type, src: '', opacity: 1, placeHolder: '' }
            }
        },
        replaceImg ( item, field = 'src' ) {
            UploadFile(resp => {
                item.opacity = 0;
                postMinify(resp.result,resp => {
                    item.opacity = 1;
                    this.$set(item,field,resp.url);
                    //item[field]= resp.url;
                })
            })
        },
        replaceHomeBannerPlaceHolder () {
            this.replaceImg ( this.homeBanner, 'placeHolder') 
        },
        replaceHomeBannerImage () {
            this.replaceImg( this.homeBanner );
        },
        exit () {
            this.$router.push('/')
        },
        save ( menu ) {
            menu.forEach(item => delete item.opacity);
            this.exit();
            WebSoc.SEND('update',{ DB: 'clients', _id: this.client_id, update: { $set: { /* menu: this.menu, */ homeBanner: this.homeBanner } } },() => {
                Alert.message('Home Page Updated');
            });
        }
    }    
}

</script>

<style lang="scss">
.list-container {
    header {
        width: 100%;
        border-bottom: 1px solid #c0c0c0;
        p { line-height: 38px; margin: 0px 10px; }
    }
    .label {
        float: left;
        width: calc(100% - 20px);
        margin: 10px;
    }
}
.list-container.home-buttons {
    .menu-items {
        float: left;
        width: calc(100% - 20px);
        margin: 10px;
        .menu-item {
            display: grid;
            margin-bottom: 10px;
            grid-template-columns: 200px 1fr;
        }
    }
}
</style>